import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { getProjectvariationById } from "../projectVariations";
import { queryKeys } from "../queryKeys";
import { useMemo } from "react";
import { InspectionResponse } from "src/types/InspectionUpdateRequest";

export function useProjectVariationById(id?: string) {
  const { companyId, variationId, inspectionId, deviationId } = useParams();
  const idToUse = useMemo(() => {
    return id ?? inspectionId ?? variationId ?? deviationId;
  }, [id, variationId, inspectionId, deviationId]);
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: queryKeys.selectedVariation(idToUse!),
    queryFn: () =>
      getProjectvariationById(companyId, idToUse).then((res) => {
        queryClient.invalidateQueries({
          queryKey: queryKeys.files(companyId!, Number(idToUse)),
        });
        return res as InspectionResponse;
      }),
    enabled: !!idToUse,
  });
  return {
    ...query,
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.selectedVariation(idToUse!),
      }),
    enabled: !!idToUse,
  };
}
